import React from "react";
import classNames from "classnames/bind";
import { motion } from "framer-motion";

// assets
import { CloseIcon, ArrowNextIcon, DirectionIcon } from "src/assets/icons";

import styles from "./Footer.module.scss";
const cx = classNames.bind(styles);

const Footer = ({ activeRef, length, handleClose, handleNextSlide }) => {
  const viewGoogleMap = () => {
    window.open(
      `https://www.google.com/maps/search/?api=1&query=${activeRef.current.Latitude}%2C${activeRef.current.Longitude}`
    );
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 100 }}
      animate={{
        opacity: 1,
        y: 0,
        transition: { duration: 0.25, delay: 0.2 },
      }}
      exit={{
        opacity: 0,
        y: 100,
        transition: { duration: 0.25 },
      }}
      className={cx("mob-map-footer-root")}
    >
      <div className={cx("content")}>
        <span className={cx("icon-wrapper")} onClick={handleClose}>
          <CloseIcon />
        </span>
        <button className={cx("direction-btn")} onClick={viewGoogleMap}>
          <DirectionIcon /> <span>Get Direction</span>
        </button>
        <div className={cx("next-btn")} onClick={handleNextSlide}>
          <span className={cx("icon-wrapper")}>
            <ArrowNextIcon />
          </span>
          <span className={cx("count")}>
            <span>+{length - activeRef?.index}</span>
          </span>
        </div>
      </div>
    </motion.div>
  );
};

export default Footer;
